export enum DisplayType {
	BLOCK = 'block',
	INLINE = 'inline',
}
